export default __webpack_public_path__ + "static/media/155335940_188876169678137_4985832658479499287_n.7e482f9d.jpg";